module.exports = __webpack_public_path__ + "img/角龍之介.58778d16.jpg";